import { TextField, Button } from "@mui/material"
import { useTranslation } from "react-i18next"

import { ResponsiveDrawer } from "@/components"
import StyledHelperText from "@/components/StyledHelperText"

interface PartnerCodeDialogProps {
  isOpen: boolean
  code: string
  error?: string
  onClose: () => void
  onCodeChange: (code: string) => void
  onSubmit: () => void
}

const PartnerCodeDialog = ({
  isOpen,
  code,
  error,
  onClose,
  onCodeChange,
  onSubmit,
}: PartnerCodeDialogProps) => {
  const { t } = useTranslation()
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit()
  }

  return (
    <ResponsiveDrawer
      open={isOpen}
      onClose={onClose}
      title={t("partnerCodeInput.title")}
      footer={
        <>
          <Button type="button" variant="outlined" onClick={onClose}>
            {t("partnerCodeInput.cancelButtonLabel")}
          </Button>
          <Button form="partnerCodeForm" type="submit" variant="contained">
            {t("partnerCodeInput.submitButton")}
          </Button>
        </>
      }
    >
      <form onSubmit={handleSubmit} id="partnerCodeForm">
        <TextField
          fullWidth
          autoFocus={false}
          label={t("partnerCodeInput.label")}
          placeholder={t("partnerCodeInput.placeholder")}
          value={code}
          onChange={(e) => onCodeChange(e.target.value)}
          helperText={
            error ? (
              <StyledHelperText helperText={error} severity="error" />
            ) : undefined
          }
        />
      </form>
    </ResponsiveDrawer>
  )
}

export default PartnerCodeDialog
